(() => {
  const map=window.ACTICLEAR_ASSETS;
  const paths=Object.keys(map).sort((a,b)=>b.length-a.length);
  function rewrite(value){
    if(typeof value==='string'){
      for(const path of paths) value=value.split(path).join(map[path]);
      return value;
    }
    if(Array.isArray(value))return value.map(rewrite);
    if(value&&typeof value==='object'){for(const key of Object.keys(value))value[key]=rewrite(value[key]);}
    return value;
  }
  for(const key of ['ACTICLEAR_CATALOG','ACTICLEAR_POLICIES','ACTICLEAR_MEDIA','ACTICLEAR_CONTENT','ACTICLEAR_SERVICE','ACTICLEAR_HOME'])rewrite(window[key]);
})();
